/**
 * Fælles fetch-helper — KANONISK placering.
 *
 * Samme implementering som de lokale kopier i useIntegrations/useTelefon/
 * useStores/useBudget (fejlformat '<status> <statusText>: <body>'); nye
 * composables skal importere HERFRA i stedet for at kopiere. De fire
 * eksisterende kopier kan migreres hertil som separat oprydning.
 */

export async function fetchJson<T>(input: string, init?: RequestInit): Promise<T> {
  // Sæt kun content-type når der faktisk sendes en body — Fastify v5 afviser
  // tomme POST-bodies med application/json-header.
  const headers = new Headers(init?.headers);
  if (init?.body != null && !headers.has('content-type')) {
    headers.set('content-type', 'application/json');
  }
  const res = await fetch(input, { ...init, headers });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`${res.status} ${res.statusText}: ${text}`);
  }
  return (await res.json()) as T;
}
